// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2xBUf","full":"styles_full__3FJBs","icon":"styles_icon__1Emz1"};